import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { faEdit, faTrash, faCommentSlash, faMessage, faFilePen, faDownload, faWarning, faLock } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { UserService } from 'src/app/services/user.service';
import { DeleteCommentComponent } from '../../delete-comment/delete-comment.component';
import { NewCommentComponent } from '../../new-comment/new-comment.component';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { Subject } from 'rxjs/internal/Subject';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'
const pdfMakeX: any = pdfMake;
const pdfFontsX: any = pdfFonts;
pdfMakeX.vfs = pdfFontsX.vfs;
import htmlToPdfMake from 'html-to-pdfmake';

@Component({
    selector: 'app-print-report-2500-8',
    templateUrl: './print-report-2500-8.component.html',
    styleUrls: ['./print-report-2500-8.component.scss', '../../report-comments.scss'],
    standalone: false
})


export class PrintReport25008Component implements OnInit {
  //icons
  faEdit = faEdit;
  faTrash = faTrash;
  faCommentSlash = faCommentSlash;
  faMessage = faMessage;
  faFile = faFilePen;
  faDownload = faDownload;
  faWarning = faWarning;
  faLock = faLock;

  report_page: number = 0;
  updateReportSubject = new Subject<any>();

  report: any;
  report_status: any;
  nav: string = '';
  comment_expand: boolean = false;
  comments: any;
  comments_unresolved: boolean = false;
  reportSections: any;

  currentUser: any;
  is_co: boolean = false;
  is_woco: boolean = false;
  editable: boolean = false;
  canEdit: boolean = false;
  signable: boolean = false;
  submitable: boolean = false;
  submitValid: boolean = false;
  autosave: any = { saving: false };
  lockStatus = {
    regionalFunds: true,
    regionalApproval: true,
    woFunds: true,
    woApprovals: true,
  }

  pages = [
    { name: "Report Type", id: "report-type" },
    { name: "Burned Area Description", id: "burned-area" },
    { name: "Watershed Condition", id: "watershed-condition" },
    { name: "Summary of Analysis", id: "analysis-summary" },
    { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
    { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
    { name: "Team & Supporting Documents", id: "team-supporting" },
    { name: "Select Forest Unit Line Officer(s)", id: "select-line-officer" },
  ]

  report_type = "funding"
  @ViewChild('printContainer') reportPDF!: ElementRef;
  loaded = [false, false, false, false, false, false, false, false]

  constructor(
    public dialogRef: MatDialogRef<PrintReport25008Component>,
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly userService: UserService,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.titleService.setTitle("BAER - Report");
    this.reportSections = this.reportService.getReportPageList();
  }

  ngOnInit(): void {
    this.getReport()
  }

  subLoaded(page: any) {
    this.loaded[page - 1] = true;
    const allLoaded = this.loaded.reduce((acc, val) => acc && val, true);
    if (allLoaded) {
      setTimeout(() => {
        this.exportPDF();
        this.dialogService.closeSpinner();
        this.dialogRef.close();
      }, 1000);
    }
  }

  updateReportType(report: any) {
    if (report.report_type != this.report_type) {
      this.report_type = report.report_type

      if (this.report_type == "No Treatment") {
        this.loaded[4] = true;
        this.loaded[5] = true;
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Watershed Condition", id: "watershed-condition" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Assessment Cost", id: "assessment-cost" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      } else if (this.report_type == "Pre-assessment Request") {
        this.loaded[2] = true;
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
          { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      } else {
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Watershed Condition", id: "watershed-condition" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
          { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      }
    }
  }

  /**
   * Conccurent calls so it can be faster
   */
  getReport() {
    this.dialogService.openSpinner();
    let report: any = {}
    let promise1 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.data.report_id, ["forests", "forests.treatments", "forests.treatments.treatment_specifications", "forests.line_officer"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.forests = r.forests
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    let promise2 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.data.report_id, ["users", "users.user", "users.skills.skill", "signatures"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.users = r.users
          report.signatures = r.signatures
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    let promise3 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.data.report_id, ["assessment", "stateCounties", "supporting_files", "watersheds", "soil_burn_severities"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          for (let field in r) {
            report[field] = r[field]
          }
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    Promise.all([promise1, promise2, promise3]).then((result) => {
      this.updateReportType(report);
      this.report = report;
      this.titleService.setTitle(`BAER - ${this.report.baer_name} (${this.report.report_num}) Report`);
      this.setReportComments();
      this.nav = '';
      this.editable = this.report.report_status_id != 2; // SUBMITTED
      this.loadUser();
      this.subLoaded(1);
    }).catch((error: any) => {
      console.log(error)
      this.dialogRef.close();
      this.dialogService.closeSpinner();
      this.toast.openErrorSnackBar(`There was an error downloading the report.`, "Please try again.");
    })
  }
  exportPDF() {

    pdfMake.fonts = {
      'Roboto': {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    const reportPDF = this.reportPDF.nativeElement.innerHTML;
    let start = "<fa-icon";
    let end = "</fa-icon>";
    // Create a regular expression to match the content between the start and end
    const regex = new RegExp(`(?<=${start}).*?(?=${end})`, 'g');

    start = 'class="user-icon">'
    end = '</div>'
    const regex2 = new RegExp(`(?<=${start}).*?(?=${end})`, 'g');
    const cleanedtext = reportPDF.replaceAll(regex, '').replaceAll(regex2, '</div>').replaceAll('keyboard_arrow_down', '').replaceAll('chevron_right', '').replaceAll('>location_on<', '>location: <').replaceAll('>email<', '>email: <').replaceAll('>phone<', '>phone: <').replaceAll('info_outline','').replaceAll('View full size image','').replaceAll('Sign & Certified','')
    let margin0: [number,number,number,number] = [0,0,0,10]
    let margin1: [number,number,number,number] = [0,0,0,0]
    const options = {
      defaultStyles: {
        h1: { fontSize: 16, bold: true, marginBottom: 10 },
        h2: { fontSize: 14, bold: true, marginBottom: 10 },
        h3: { fontSize: 12, bold: true, marginBottom: 10 },
        p: { margin: margin0},
        b: { marginTop: 10, paddingTop: 10},
        div: {margin: margin1}
      }
    };

    const html = htmlToPdfMake(cleanedtext, options);
    const styles = {
      "title": {
        "bold": "true",
        "fontSize": "14",
        "margin": [0, 10, 0, 0]
      },
      "data-title": {
        "bold": "true",
        "fontSize": "12"
      },
      "form-header": {
        "fontSize": "14",
        "margin": [0, 10, 0, 0]
      },
      "html-b": {
        "margin": [0, 10, 0, 0],
        "fontSize": "12"
      },
      "user-name": {
        "color": "black",
        "decoration": [],
        "margin": [0, 10, 0, 0],
        "bold": "true",
        "fontSize": "14"
      },
      "report-section": {
        "margin": [0, 10, 0, 0]
      },
      "site-page-title": {
        "fontSize": "14"
      }
    }
    const docDefinition: any = { content: html, styles: styles };
    const pdfName = this.report.report_id + ' - ' + this.report.baer_name + '.pdf';
    pdfMake.createPdf(docDefinition).download(pdfName);
  }

  loadUser() {
    this.userService.getUserProfile().then(async (user) => {
      this.currentUser = user;
      if ((this.currentUser.isROCO?.length ?? 0) > 0) this.is_co = true;
      if (this.currentUser.isWO) this.is_woco = true;
      let lead_ids = this.report.users.filter((user: any) => user.editor)?.map((x: any) => x.user_id) ?? [];
      lead_ids.push(this.report.assessment.team_lead_id);
      if (this.currentUser.isWO ||
        lead_ids.includes(user.user_id) ||
        ((this.currentUser.isFOCO.length >= 1) && (this.report.assessment.forest_name.includes(user.forest_name))) ||
        ((this.currentUser.isROCO.length >= 1) && (this.report.assessment.region.includes(user.region)))
      ) this.canEdit = true;
      this.updateSignable();
      this.updateLockStatus();
    });
  }

  save_close() {
    this.nav = 'close'
  }

  forward() {
    this.nav = 'forward'
  }

  back() {
    this.nav = 'back'
  }

  updateSignable() {
    this.signable = false
    this.submitable = false
    if (this.report.report_status_id == 2) {
      this.checkAuthStatus();
    }
  }

  checkAuthStatus() {
    switch (this.report.authorization_status_id) {
      case 0: // FOLO signature requested
        if (this.currentUser.isFOLO) {
          let forests: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "FOLO").map((role: any) => role.forest_name)
          this.signable = this.report.forests.find((forest: any) => forests.includes(forest.forest_name))
        }
        break;
      case 1: // ROLO signature requested
        if (this.currentUser.isROLO) {
          let regions: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "ROLO").map((role: any) => role.region)
          this.signable = this.report.forests.find((forest: any) => regions.includes(forest.region))
        }
        break;
      case 2: // WO signature requested
        if (this.currentUser.isWOLO)
          this.signable = true
        break;
      case 3: // Review RO funding
        if (this.currentUser.isROCO) {
          let regions: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "ROCO").map((role: any) => role.region)
          this.submitable = this.report.forests.find((forest: any) => regions.includes(forest.region))
        }
        break;
      case 5: // Review WO funding
        if (this.currentUser.isWO)
          this.submitable = true
        break;
      case 6: // done
        break;
    }
  }

  setReportComments() {
    this.reportService.getReportComments(this.data.report_id).subscribe((reportComments: any) => {
      this.comments = reportComments.reportCommentEntities;
      let findUnresolved = this.comments.find((x: any) => !x.resolved)
      if (findUnresolved ?? false) this.comments_unresolved = true;
    })
  }

  addComment() {
    this.dialog.open(NewCommentComponent, {
      width: "600px",
      data: {
        'report_num': this.report_page,
        report_id: this.data.report_id,
        edit: false,
        user: this.currentUser
      },
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  editComment(comment: any) {
    this.dialog.open(NewCommentComponent, {
      width: "600px",
      data: {
        'report_num': comment.section,
        report_id: this.data.report_id,
        comment: comment,
        edit: true,
        user: this.currentUser
      },
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  deleteComment(comment: any) {
    this.dialog.open(DeleteCommentComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        comment_id: comment.report_comment_id
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  markAsResolved(comment: any, resolved: boolean) {
    this.reportService.editReportComment({
      resolved: resolved
    }, comment.report_comment_id).subscribe({
      next: (response) => {
        comment.resolved = resolved
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error marking commment ${resolved ? 'resolved' : 'unresolved'}`, "Please try again.");
      },
    });
  }

  findPage(pageNum: any) {
    return this.reportSections.find((x: any) => x.pageNum == pageNum).pageName;
  }

  updateLockStatus() {

    if (this.report.authorization_status_id == 0) { // LO signature requested
      this.report.page_8_status_id = 0
    }

    this.lockStatus = {
      regionalFunds: true,
      regionalApproval: true,
      woFunds: true,
      woApprovals: true,
    }
    if (this.is_co) {
      this.lockStatus.regionalFunds = false
      this.lockStatus.regionalApproval = false
    }
    if (this.is_woco) {
      this.lockStatus.woFunds = false
      this.lockStatus.woApprovals = false
    }
    if (this.report.authorization_status_id != 1) { // awaiting LO signature
      this.lockStatus.regionalApproval = true // regional lo can't sign off until forest LO sign off
    }
    if (this.report.authorization_status_id != 2) { // awaiting WO signature
      this.lockStatus.woApprovals = true // wo lo can't sign off until forest regional
    }
    if (this.report.authorization_status_id != 3) { //RO FUNDING
      this.lockStatus.regionalFunds = true
    }
    if (this.report.authorization_status_id != 5) {//WO FUNDING
      this.lockStatus.woFunds = true
    }

    if (this.report.regional_approval_status_id == 2) {
      this.lockStatus.regionalApproval = false // unlock if complete
    }
    if (this.report.wo_approval_status_id == 2) {
      this.lockStatus.woApprovals = false // unlock if complete
    }
    if (this.report.regional_funding_status_id == 2) {
      this.lockStatus.regionalFunds = false // unlock if complete
    }
    if (this.report.wo_funding_status_id == 2) {
      this.lockStatus.woFunds = false // unlock if complete
    }
  }

  updateSumbitValid(value: boolean) {
    this.submitValid = value
  }
}
